import type { FusionAuthProviderConfig } from '@fusionauth/react-sdk';

export default {
  serverUrl: import.meta.env.VITE_FA_URL,
  clientId: import.meta.env.VITE_FA_CLIENT_ID,
  redirectUri: window.location.toString().split('/').slice(0, 3).join('/'), // protocol, host, and port
  shouldAutoFetchUserInfo: true,
} as FusionAuthProviderConfig;
